import { updateHistoryStackAfterDraw } from '../../utils/undoRedoUtils.js'

/**
 * 펜 그리기 종료 처리 (mouseup / touchend)
 * - 히스토리 저장
 * - path 초기화
 */
export const handlePenUp = (state) => {
  const { boardId, currentPath, currentPathId, historyStack, setHistoryStack } = state

  // [undo/redo] 기록 스택에 현재 경로 저장
  updateHistoryStackAfterDraw({
    boardId,
    currentPath,
    currentPathId,
    historyStack,
    setHistoryStack,
  })

  // 상태 초기화
  currentPath.current = null
  currentPathId.current = 0
}
